module.exports = __webpack_public_path__ + "img/kund3.bf20c2e2.jpg";